import React from 'react';
import { ProductCard } from '../../molecules';

/**
 * ProductGrid Organism Component
 * Displays a grid of product cards
 */
const ProductGrid = ({ 
  products = [],
  onAddToCart,
  className = '',
  ...props 
}) => {
  if (products.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">No products available</p>
      </div>
    );
  }

  return (
    <div 
      className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 ${className}`}
      {...props}
    >
      {products.map((product) => (
        <ProductCard
          key={product.id || product._id}
          product={product}
          onAddToCart={onAddToCart}
        />
      ))}
    </div>
  );
};

export default ProductGrid;

